import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, Chip, Typography } from '@mui/material';
import { useFamilyChild } from './FamilyShell';
import { parentApi } from './parentApi';
import { formatCivilDay } from './familyFormat';

const FILTERS = [
  { id: 'todo', label: 'To do' },
  { id: 'sent', label: 'Sent' },
  { id: 'reviewed', label: 'Reviewed' },
];

export default function FamilyHomework() {
  const { child } = useFamilyChild();
  const navigate = useNavigate();
  const [filter, setFilter] = useState('todo');
  const q = useQuery(
    ['familyHomework', child.studentId],
    async () => (await parentApi.homework(child.studentId)).data?.data || [],
    { enabled: !!child.studentId }
  );
  const rows = (q.data || []).filter((r) => (filter ? r.status === filter : true));

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 1 }}>Homework</Typography>
      <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
        {FILTERS.map((f) => (
          <Chip key={f.id} label={f.label} color={filter === f.id ? 'primary' : 'default'} onClick={() => setFilter(f.id)} />
        ))}
      </Box>
      {rows.length === 0 && (
        <Typography color="text.secondary">
          {filter === 'todo' ? `Nothing due for ${child.firstName}.` : 'Nothing in this list yet.'}
        </Typography>
      )}
      {rows.map((r) => (
        <Box
          key={r.sessionId}
          onClick={() => navigate(`/family/homework/${r.sessionId}`)}
          sx={{ py: 1.5, borderBottom: '1px solid rgba(27,42,74,0.08)', cursor: 'pointer' }}
        >
          <Typography fontWeight={600}>
            {r.instruction
              ? String(r.instruction).slice(0, 80)
              : r.images?.length
                ? 'Screenshot homework'
                : 'Homework'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {formatCivilDay(r.date)} class · {r.statusLabel}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
